import {
  getAuthIsLoggedIn,
  getAuthSessionChecked,
} from 'modules/auth/selectors';

import { connect } from 'react-redux';
import { getMeItem } from 'modules/me/selectors';
import PrivateRoute from './private-route';

const mapStateToProps = (state) => ({
  isLoggedIn: getAuthIsLoggedIn(state),
  sessionChecked: getAuthSessionChecked(state),
  me: getMeItem(state),
});

export default connect(mapStateToProps)(PrivateRoute);
